var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticClass:"tiny",attrs:{"id":_vm.Id}})])}
var staticRenderFns = []

export { render, staticRenderFns }